"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.BillingApiChargeCancelActionEnum = void 0;
var BillingApiChargeCancelActionEnum;
(function (BillingApiChargeCancelActionEnum) {
  /** Начисление не требовало действия */
  BillingApiChargeCancelActionEnum["NO_ACTION"] = "NO_ACTION";
  /** Произведена простая отмена, оплаты не было, возвращать нечего */
  BillingApiChargeCancelActionEnum["CANCELLED"] = "CANCELLED";
  /** Произведена отмена с возвратом */
  BillingApiChargeCancelActionEnum["REFUNDED"] = "REFUNDED";
})(BillingApiChargeCancelActionEnum = exports.BillingApiChargeCancelActionEnum || (exports.BillingApiChargeCancelActionEnum = {}));
